import PropTypes from "prop-types";

const commonFilterConditionPropTypes = {
  idx: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export { commonFilterConditionPropTypes };
